<template>
	<div class="h-header">
		<div class="h-headL">
			<a class="h-logo1"><img src="../assets/images/h-logo1-icon.png"></a>
		</div>
		<div class="h-headR">
			<a class="h-logo2"><img src="../assets/images/h-logo2-icon.png"></a>
			<div class="h-fr h-disTable">
				<div class="h-tableCell">
<!--					&lt;!&ndash;暂时隐藏&ndash;&gt;-->
<!--					<div class="h-headLink" >-->
<!--						<el-tooltip content="消息中心" effect="light">-->
<!--							<a @click="toMsgCenter" title="消息中心">-->
<!--								<img src="../assets/images/h-header-icon1.png">-->
<!--								<span v-if="this.$store.getters.checkedTotal !== 0" class="h-linkNum">{{this.$store.getters.checkedTotal}}</span>-->
<!--							</a>-->
<!--						</el-tooltip>-->
<!--					</div>-->
<!--					<div class="h-headLink" >-->
<!--						<el-tooltip content="待办中心" effect="light">-->
<!--							<a @click="toTaskCenter" title="待办中心">-->
<!--								<img src="../assets/images/h-header-icon2.png">-->
<!--								<span v-if="this.$store.getters.tasktotal !== 0"class="h-linkNum">{{this.$store.getters.tasktotal}}</span>-->
<!--							</a>-->
<!--						</el-tooltip>-->
<!--					</div>-->
<!--					<div class="h-headLink" style="color:#fff">-->
<!--						<a @click="toUserCenter">-->
<!--							{{this.$store.getters.user.username}}[{{this.$store.getters.user.usercode}}]-->
<!--						</a>-->
<!--					</div>-->
<!--					<div class="h-headLink" style="color:#fff">-->
<!--						<a @click="tuichu">-->
<!--							退出系统-->
<!--						</a>-->
<!--					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import {
        Loading,
        Message,
        MessageBox
    } from 'element-ui';
export default {
	name:'Commonheader2',
	methods:{
        toMsgCenter(){
            this.$router.push({path:"/personal/messageCenter"})
        },
        toTaskCenter(){
            this.$router.push({path:"/personal/dealCenter"})
        },
        toUserCenter(){
            this.$router.push({path:"/personal/userin"})
		},
        tuichu(){
            this.$msg.confirm("确认退出？",()=> {
                this.$store.commit("LOGOUT")
            })
		}
	},
	created(){
	//    加载消息
        this.$store.dispatch('searchMsgPage');
        this.$store.dispatch('searchTasktotal');
		this.$store.dispatch('searchCheckedTotal');
		// var aa = localStorage.getItem("_alert_msg_");
		// if(!aa){
        //     this.$notify({
        //         title: '系统提醒',
        //         message: '系统在7月2日零时停机维护，持续时间1个小时，对于系统维护给您带来的不便，敬请谅解，感谢大家的支持和配合',
        //         type: 'warning',
        //         duration: 0,
        //         onClose:function () {
        //             localStorage.setItem("_alert_msg_","1")
        //         }
        //     });
		// }

	}
}
</script>

<style>
</style>
